import { useState, useEffect, useRef } from 'react';
import {  } from 'react-router-redux';
import { useSelector, useDispatch } from 'react-redux';
import { withRouter } from 'react-router-dom';

import Audio from '../../services/audioCache';
import useConnector from '../../hooks/useConnector';
import { gridtoolsActions, playersActions, chatActions, charactersActions, jukeboxActions, turnorderActions, assetsActions, messagesActions, profilesActions, timersActions, loadingActions } from '../../redux/actions';


export default withRouter(({match, location}) => {

    const [tableId, setTableId] = useState('');

    const connector = useConnector();

    const dispatch = useDispatch();
    const jumpToTab = useSelector(state => state.configState.jumpToTab);

    const currentTab = useRef(null);

    useEffect(() => {
        currentTab.current = jumpToTab;
    }, [jumpToTab]); 

    useEffect(() => {
        dispatch(loadingActions.setConnectionStatus(connector.ws.isOnline ? 'online' : 'offline'));
    }, [connector.ws.isOnline]);    

    useEffect(() => {
        connector.setTableId(tableId);
    }, [tableId]);

    useEffect(() => {
        let match = new RegExp('^/(table|streamlink)/([a-zA-Z0-9]*)','gi').exec(location.pathname);
        if (match && match.length === 3) {
            setTableId(match[2]);
        } else {
            setTableId('0');
        }
    }, [location]);

    useEffect(() => {
        connector.on('userEnter', (i) => {
            dispatch(playersActions.setOnline({user: i.data.name, email: i.data.email, color: i.data.color}));
        });
        connector.on('userLeave', (i) => {
            dispatch(playersActions.setOffline({user: i.data.name, color: i.data.color, email: i.data.email}));
                        
        });
        connector.on('gridSync', (i) => {
            dispatch(gridtoolsActions.setSyncRender(i.data));
        });
        connector.on('gridSyncInsert', (i) => {
            dispatch(gridtoolsActions.setSyncRenderOperation('insert',i.data));
        });
        connector.on('gridSyncUpdate', (i) => {
            dispatch(gridtoolsActions.setSyncRenderOperation('update',i.data));
        });
        connector.on('gridSyncDelete', (i) => {
            dispatch(gridtoolsActions.setSyncRenderOperation('delete',i.data));
        });
        connector.on('gridSyncChangeLayer', (i) => {
            dispatch(gridtoolsActions.setSyncRenderOperation('changeLayer',i.data));
        });
        connector.on('propsGridSync', (i) => {
            dispatch(gridtoolsActions.setSyncPropsGrid(i.data));
        });
        connector.on('gridSyncChangeOrderr', (i) => {
            dispatch(gridtoolsActions.setSyncRenderOperation('changeOrder',i.data));
        });
        connector.on('signalSync', (i) => {
            dispatch(gridtoolsActions.recevingSignal(i.data));
        });
        connector.on('measureSync', (i) => {
            dispatch(gridtoolsActions.recevingMeasure(i.data));
        });
        connector.on('movingSync', (i) => {
            dispatch(gridtoolsActions.recevingMoving(i.data));
        });
        connector.on('measureClear', (i) => {
            dispatch(gridtoolsActions.clearMeasure(i.data));
        });
        connector.on('playersSync', (i) => {
            dispatch(playersActions.loadPlayers(null, i.data));
        });
        connector.on('assetUpdate', (i) => {
            dispatch(assetsActions.updateAsset(i.data));
        });
        connector.on('assetContentUpdate', (i) => {
            dispatch(assetsActions.updateContent(i.data));
        });
        connector.on('assetShow', (i) => {
            try {
                dispatch(assetsActions.openWindow(JSON.parse(i.data)));
            } catch (e) {
                console.error(Object.assign(e,{component:'AssetS', id: 'parseAssetShow'}));
            }
        });
        connector.on('chatMessage', (i) => {
            let msg = JSON.parse(i.data);
            dispatch(chatActions.addMessage(msg));
            dispatch(chatActions.stopTypingMessage(msg.name));
            if (window.focusOff || currentTab.current !== 0) {
                Audio.play('notify');
            }
        });
        connector.on('typingMessage', (i) => {
            dispatch(chatActions.typingMessage(i.data));
        });
        connector.on('tokenSync', (i) => {
            dispatch(charactersActions.updateToken(i.data));
        });
        connector.on('charSync', (i) => {
            dispatch(charactersActions.updateCharacters(i.data));
        });
        connector.on('charUpdateSync', (i) => {
            let idupdate = i.data.id;
            let char = i.data.char;
            dispatch(charactersActions.updateChar(idupdate, char));
        });
        connector.on('charRemoveSync', (i) => {
            let idremove = i.data.id;
            dispatch(charactersActions.removeChar(idremove));
        });
        connector.on('charMultiRemoveSync', (i) => {
            let ids = i.data.ids ?? [];
            dispatch(charactersActions.removeMultiChar(ids));
        });
        connector.on('charCopySync', (i) => {
            let idparent = i.data.id;
            let childrenChars = i.data.chars;
            dispatch(charactersActions.updateChildrenChar(idparent, childrenChars));
        });
        connector.on('templateSync', (i) => {
            dispatch(charactersActions.setSheetTemplate(i.data));
        });
        connector.on('jukeboxPlayYT', (i) => {
            dispatch(jukeboxActions.startPlay(i.data.videoId));
        });
        connector.on('jukeboxStopYT', (i) => {
            dispatch(jukeboxActions.stopPlay(i.data.videoId));
        });
        connector.on('turnOrderSync', (i) => {
            dispatch(turnorderActions.setTurnOrders(i.data.turnOrders));
        });
        connector.on('frienListUpdate', (i) => {
            dispatch(profilesActions.setUpdateFriendlist());
        });
        connector.on('timersChange', (i) => {
            dispatch(timersActions.updateTimers(i.data));
        });
        connector.on('profileMessageSent', (i) => {
            try {
                let d = JSON.parse(i.data);
                dispatch(messagesActions.receveMessage(d.from, d.to, d.message, d.name, d.from));
            } catch (e) {
                console.error(Object.assign(e,{component:'Messages', id: 'parseMessageReceived'}));
            }
        });
    }, []);

    return null;
});